import { Network, enums, helpers } from '@kattana-io/common';
const { toChecksumAddress } = require('ethereum-checksum-address');

/**
 * Temporary solution for trading widget
 * @param input - address
 * @returns - checksummed address
 */
const toChecksumAddressWrapper = (input: string): string => {
  try {
    if (input[0] === '0') {
      return toChecksumAddress(input);
    }
    return input;
  } catch (e) {
    console.warn(input + ' is not a valid Ethereum address.');
    return input;
  }
};

interface IIconProvideArguments {
  ticker?: any;
  network: Network;
  exchange?: string;
  contract?: string;
  kind: enums.ETickerKind;
}
/**
 * Implements a class which does routing for icons
 */
class IconProvider {
  kind: enums.ETickerKind | undefined;
  network: Network | undefined;
  contract: string | undefined;
  name: string | undefined;
  ticker: any;
  exchange: string | undefined;

  constructor({ ticker, network, exchange, contract, kind }: IIconProvideArguments) {
    this.ticker = ticker;
    this.network = network;
    this.contract = contract;
    this.kind = kind;
    this.exchange = exchange;
  }

  static createFromNetworkAndPair(network: Network, pair: string | undefined) {
    return new IconProvider({
      network,
      contract: pair,
      kind: 2
    });
  }

  static createFromExchangeAndContract(exchange: string, contract: string, chain: string) {
    const network = Network.fromChain(chain);
    return network ? new IconProvider({
      network,
      exchange,
      contract,
      kind: 2
    }) : null;
  }

  url = (): string => {
    // if (this.exchange) {
    // }
    if (this.network && this.contract) {
      if (this.network.isELROND()) {
        return `https://raw.githubusercontent.com/ElrondNetwork/assets/master/tokens/${this.contract}/logo.svg`;
      }
      if (this.network.isMETER()) {
        return `https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/meter/${this.contract}.svg`;
      }
      if (this.network.isHECO()) {
        return `https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/heco/${toChecksumAddressWrapper(this.contract)}.png`;
      }
      if (this.network.isAVAX()) {
        return `https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/${toChecksumAddressWrapper(this.contract)}/logo.png`;
      }
      if (this.network.isOKX()) {
        if (this.contract === '0x8F8526dbfd6E38E3D8307702cA8469Bae6C56C15') {
          return 'https://kattana-icons.s3.amazonaws.com/okt.png';
        } else {
          return `https://raw.githubusercontent.com/kattana-io/additional-icons/main/blockchains/okc/${this.contract.toLocaleLowerCase()}.png`;
        }
      }
      if (this.network.isTron()) {
        if (this.contract === 'TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR') {
          return 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/tron/info/logo.png';
        }
        return `https://assets.trustwalletapp.com/blockchains/tron/assets/${this.contract}/logo.png`;
      }
      return `https://assets.trustwalletapp.com/blockchains/${this.network.toTrustWallet()}/assets/${toChecksumAddressWrapper(this.contract)}/logo.png`;
    }
    return '';
  }
}

export default IconProvider;
